export default __webpack_public_path__ + "static/media/agbad.b73af4b8.jpg";